module.exports = __webpack_public_path__ + "img/clapped-hand.581cd993.svg";